import { render, staticRenderFns } from "./Blocked.vue?vue&type=template&id=f5d2c59e&scoped=true&lang=html&"
import script from "./Blocked.vue?vue&type=script&lang=js&"
export * from "./Blocked.vue?vue&type=script&lang=js&"
import style0 from "./Blocked.vue?vue&type=style&index=0&id=f5d2c59e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d2c59e",
  null
  
)

export default component.exports